/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type ContractRateKind = typeof ContractRateKind[keyof typeof ContractRateKind];


export const ContractRateKind = {
  regular: 'regular',
  exclusive: 'exclusive',
} as const;
